import { createFilterListStore } from '~/features/filter-list'

export const { useFilterListVisibilityStore } = createFilterListStore()
